const data = [
  // "widget_logo", //logo
  "symbol_info", //product information dialog
  "timezone_men", //Product info dialog disables timezone context menu
  // "go_to_date", //Go to (select time period)
  "compare_symbol", //Remove Compare/Overwrite dialog from menu
  // "left_toolbar", //left toolbar
  // "pane_context_menu", //Icon right-click menu
  "volume_force_overlay", //Place volume indicators on the same pane of the main data column to prevent them from overlapping
  "pane_context_menu",
  "contextmenu",
  "scales_context_menu",
  "legend_context_menu",
  "display_market_status",
  "timeframes_toolbar", //bottom time bar
  "snapshot_trading_drawings", //Contains the order/position/execution signal in the screenshot
  "use_localstorage_for_settings", //Allow saving user settings to localstorage
  "header_undo_redo", //Head left and right arrows
  "header_compare", //Head comparison information button
  "header_settings", //Settings button
  "header_resolutions", //Time selection, time-sharing switching
  // "header_screenshot", //screenshot camera
  "header_chart_type", // K line style
  // 'property_pages',// Disable all property pages
  // "header_saveload",
  // "control_bar",//Associated with the navigation buttons at the bottom of the chart
  // "legend_widget",// Disabling this feature hides the legend widget
  // "header_layouttoggle",//Show "Choose Layout" button in header
  "header_fullscreen_button", //full screen button
  "header_indicators", //index
  // "header_chart_type",//Chart type switch
  "header_symbol_search", // head search
  // "symbol_search_hot_key",
  "header_widget", //Component dom that hides the header
  // "header_widget_dom_node", // Hide the header component
  // "header_interval_dialog_button",
  // "show_interval_dialog_on_key_press",
  // "snapshot_trading_drawings",
  //   "create_volume_indicator_by_default",
  //   "timezone_menu",
];

export default data;
